import VideoPlayerDispenserHelper from "../core/video/VideoPlayerDispenserHelper";

const safeArea = { w: 1920, h: 1080 };
const extendedArea = { w: 2240, h: 1080 };

export default class ResizeManager {
    constructor(stageManager, screenNavigator, layoutManager) {
        this._stageManager = stageManager;
        this._screenNavigator = screenNavigator;
        this._layoutManager = layoutManager;

        this._stages = stageManager.getStages();
        this._canvases = Object.values(this._stages).map(s => s.canvas);
    }

    initialize() {
        this.handleResizeBound = this.handleResize.bind(this);
        window.onorientationchange = this.handleResizeBound;
        window.onresize = this.handleResizeBound;

        this.handleResize(null);
    }

    handleResize(evt) {
        this.clearResizeTimeout();
        this._timeoutResize = setTimeout(this.resize.bind(this), 70);
    }

    clearResizeTimeout() {
        if (this._timeoutResize != null) {
            clearTimeout(this._timeoutResize);
            this._timeoutResize = null;
        }
    }

    resize() {
        var MIN_WIDTH = 0, MIN_HEIGHT = 0;//No min size for now, because videoplayer does not support this
        var w = window.innerWidth, h = window.innerHeight, dpr = window.devicePixelRatio;
        var ratio = w / h;
        var canvases = this._canvases;
        if (isNaN(dpr) || dpr == 0) dpr = 1;
        //
        var canvas = canvases[0];
        var container = canvas.parentElement;
        //NB original size is 'design' size
        if (!this.widthOriginal) {
            //NB original size is size of 'critical' area
            this.widthOriginal = canvas.width;
            this.heightOriginal = canvas.height;
        }
        //
        var ow = this.widthOriginal, oh = this.heightOriginal, ro = ow / oh;
        //
        var scale = ratio > ro ? h / oh : w / ow;
        //new canvas width and height
        //We want to fill the viewport completely, so canvas size is viewport size
        //Within this size we want the screens to be as large as possible
        //For this, scaling of UI/screens is done by scaling stage below
        var cw = Math.max(MIN_WIDTH, w);
        var ch = Math.max(MIN_HEIGHT, h);

        //log.debug("main/App.handleResize ", w, h, ratio + " , " + dpr + " , " + ow, oh, ro + " , " + cw, ch + " , " + scale);
        //
        container.style.width = "100%";
        container.style.height = "100%";
        //
        for (var i = 0; i < canvases.length; i++) {
            var canvas = canvases[i];
            canvas.getContext('2d').scale(dpr, dpr);
            canvas.width = cw * dpr;
            canvas.height = ch * dpr;
            //size and position in DOM:
            canvas.style.width = cw + "px";
            canvas.style.height = ch + "px";
        }
        for (var id in this._stages) {
            var stage = this._stages[id];
            stage.x = cw * dpr / 2;
            stage.y = ch * dpr / 2;
            stage.scaleX = stage.scaleY = scale * dpr;
        }
        //Set dimension in screen navigator (for popup overlay)
        var sw = canvas.width / stage.scaleX, sh = canvas.height / stage.scaleX;
        this._screenNavigator.setScreenDimensions(sw, sh);
        //Set unscaled viewport in layoutManager    
        var f = 1 / scale;
        //NB: values for viewportOriginal in stage coordspace
        this._layoutManager.setViewport(-.5 * cw * f, -.5 * ch * f, cw * f, ch * f, -.5 * ow, -.5 * oh, ow, oh);
        //Debug:
        if (false && this.debugModel.debugLinesOn) {
            if (!this.shapeViewportDebug) this.shapeViewportDebug = stage.addChild(new createjs.Shape());
            this.shapeViewportDebug.graphics.c().s("red").ss(10).r(-.5 * cw * f, -.5 * ch * f, cw * f, ch * f);
        }

        this._resizeVideoPlayers(scale);
    }

    _resizeVideoPlayers(scale) {
        // Calculate the overflow from the extended area (2240x1080) to the safe area (1920x1080).
        // In the case of a 100% scale this would be 320px.
        const extendedWidthDelta = (extendedArea.w - safeArea.w) * scale;

        const videoPlayerIds = Object.values(VideoPlayerDispenserHelper.videoPlayerIds);
        const videoPlayerWrappers = videoPlayerIds
            .map(id => VideoPlayerDispenserHelper.getVideoWrapper(id))
            .filter(wrapper => wrapper);
        for (const videoPlayerWrapper of videoPlayerWrappers) {
            const videoElement = videoPlayerWrapper.querySelector('.ranj-video-contain .video-js video');
            videoElement.style.left = `-${extendedWidthDelta * .5}px`;
            videoElement.style.width = `calc(100% + ${extendedWidthDelta}px)`;
        }
    }
}